import { ModernSearchHit, SearchDisplay } from "frontend/types";
import { VideoTeaseProps } from "design-system/components/primitives/video-tease/video-tease";
import { isSearchHitType } from "./is-search-hit-type";

export function createModernSearchVideoTease(
  data: ModernSearchHit | SearchDisplay,
): VideoTeaseProps {
  const props: VideoTeaseProps = {
    type: "Video",
    title: data.title,
  };

  if (isSearchHitType<SearchDisplay>("modern", data)) {
    if (data.display?.date) {
      props.date = data.display.date;
    }
    if (data.display?.video?.kalturaId) {
      props.caption =
        data.display.video.caption || data.display.video.kalturaCaption;
      props.media = {
        kaltura: {
          entryId: data.display.video.kalturaId,
          title: data.title,
          withModal: true,
          className: "hbs-video-tease__kaltura-video",
          hide: {
            caption: false,
            focusables: false,
          },
          duration: data.display.video.duration,
        },
        aspectRatio: "16/9",
      };
    }
  }

  return props;
}
